"use client";

import {
  getTelegramListingPublicChannelLinks,
  TELEGRAM_LISTING_FOLLOW_DESCRIPTION,
  TELEGRAM_LISTING_FOLLOW_HEADING,
} from "@/lib/telegram/telegramListingPublicChannels";

type TelegramListingChannelsFollowProps = {
  /** Override default heading. */
  heading?: string;
  /** Override default helper copy. */
  description?: string;
  className?: string;
  /** When false, omit the outer heading (caller supplies one). */
  showHeading?: boolean;
};

/**
 * Discovery CTA: Lagos + Oyo public Telegram channels.
 * Does not claim to replace near-me alerts.
 */
export default function TelegramListingChannelsFollow({
  heading = TELEGRAM_LISTING_FOLLOW_HEADING,
  description = TELEGRAM_LISTING_FOLLOW_DESCRIPTION,
  className = "",
  showHeading = true,
}: TelegramListingChannelsFollowProps) {
  const channels = getTelegramListingPublicChannelLinks();

  return (
    <div className={className}>
      {showHeading ? (
        <div>
          <h3 className="text-sm font-semibold text-foreground">{heading}</h3>
          {description ? (
            <p className="mt-0.5 text-xs text-text-light">{description}</p>
          ) : null}
        </div>
      ) : description ? (
        <p className="text-xs text-text-light">{description}</p>
      ) : null}

      <div
        className={
          showHeading || description
            ? "mt-2 grid grid-cols-2 gap-2"
            : "grid grid-cols-2 gap-2"
        }
      >
        {channels.map((channel) => (
          <a
            key={channel.key}
            href={channel.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center rounded-md border border-border bg-surface px-3 py-2 text-sm font-medium text-foreground shadow-sm hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            {channel.label}
          </a>
        ))}
      </div>
    </div>
  );
}
